import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { IGetGameDevelopersShort } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getGameDevelopersShortInfo } from 'backend/games';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { GamesContext, IGamesContext } from 'modules/Entertainment/Games/Games/gamesState/gamesContext';
import { useTranslation } from 'react-i18next';
import style from './DeveloperSelect.module.scss';

const { Option } = Select;

const DeveloperSelect: React.FC = () => {
	const { setDeveloper, selectedDeveloper } = useContext<IGamesContext>(GamesContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetGameDevelopersShort, void>(
		getGameDevelopersShortInfo,
	);
	const { t } = useTranslation('listing');

	const value = !loading ? selectedDeveloper : undefined;

	return (
		<div className={style.container} data-test="DeveloperSelect">
			<Text translationNameSpace="listing" translationKey="developerLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setDeveloper}
				value={value}
				loading={loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.gameDevelopers.length}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{response?.data.gameDevelopers.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							{el.name}
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default DeveloperSelect;
